import { Component, input, signal } from '@angular/core';

import { StateService } from '@uirouter/core';

import { RvSpinnerDirective } from 'src/app/components/loading/rv-spinner.directive';
import { SkeletonComponent } from 'src/app/components/skeleton/skeleton.component';
import { IntegrationsCompanyDialogsService } from 'src/app/settings/services/integrations/integrations-company/integrations-company-dialogs.service';
import { IntegrationsCompanyService } from 'src/app/settings/services/integrations/integrations-company/integrations-company.service';
import { companyIntegrationOpenTarget } from 'src/app/settings/services/integrations/integrations-company/integrations-company.routing';
import { ConnectedIntegrationRow } from 'src/app/settings/services/integrations/models/integrations.types';
import { IntegrationConnectedRowComponent } from '../integration-connected-row/integration-connected-row.component';

@Component({
  selector: 'integrations-company-section',
  templateUrl: './integrations-company-section.component.html',
  styleUrl: './integrations-company-section.component.scss',
  standalone: true,
  imports: [
    IntegrationConnectedRowComponent,
    SkeletonComponent,
    RvSpinnerDirective,
  ],
})
export class IntegrationsCompanySectionComponent {
  /** Skeleton state owned by the parent while the shared company catalog loads. */
  readonly initialLoading = input(false);
  /** Spinner while the parent saves field-integration settings after a dialog. */
  readonly actionLoading = input(false);
  /** Spinner state for disconnect work after the user confirms. */
  readonly loading = signal(false);
  readonly integrations = this.integrationsCompanyService.connectedRows;

  constructor(
    private integrationsCompanyService: IntegrationsCompanyService,
    private integrationsCompanyDialogsService: IntegrationsCompanyDialogsService,
    private stateService: StateService,
  ) {}

  onManage(row: ConnectedIntegrationRow): void {
    const integration = this.integrationsCompanyService.findById(row.id);
    if (!integration) {
      return;
    }

    const target = companyIntegrationOpenTarget(integration.id);
    void this.stateService.go(target.state, target.params);
  }

  async onDisconnect(row: ConnectedIntegrationRow): Promise<void> {
    const integration = this.integrationsCompanyService.findById(row.id);
    if (!integration) {
      return;
    }

    const confirmed =
      await this.integrationsCompanyDialogsService.confirmDisconnect(
        integration,
      );
    if (!confirmed) {
      return;
    }

    this.loading.set(true);
    try {
      await this.integrationsCompanyService.disconnectIntegration(integration);
      this.integrationsCompanyDialogsService.showSuccessSnackbar(
        'Disconnected',
        integration.name,
      );
    } catch (error: unknown) {
      console.error('Failed to remove company integration:', error);
      this.integrationsCompanyDialogsService.showErrorSnackbar(
        `Failed to remove ${integration.name} integration.`,
      );
    } finally {
      this.loading.set(false);
    }
  }
}
